// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionBox_root__3fi98","question":"QuestionBox_question__azAC8","form":"QuestionBox_form__34I3o"};